import { useMemo } from 'react';

import filter from '@Components/Grid/utils/filter';
import { useGlobalStore } from '@Stores/global';

export default function useFilters() {
  const { siteSettings: { useThemeConfig } } = useGlobalStore()
  const typesConfig = useThemeConfig('types')

  const typeOptions = useMemo(() => [
    ...Object.entries(typesConfig || {}).map(([value, { plural }]) => ({ value, label: plural || value })),
    { value: 'file', label: 'File' },
  ], [typesConfig])

  return useMemo(() => [
    filter
      .options.list('entity', 'Entity', ENTITY_OPTIONS)
      .multi(true),
    filter
      .options.list('content_type', 'Type', typeOptions)
      .multi(true),
    filter.boolean('is_custom', 'Custom Route'),
    filter.boolean('is_config', 'Config Route'),
  ], [typeOptions])
}

const ENTITY_OPTIONS = [
  { label: 'Post', value: 'post' },
  { label: 'Tag', value: 'tag' },
  { label: 'Root File', value: 'root_file' },
]
